import { useEffect } from 'react';
import { useStore } from 'jotai';

import { fillSlotAtom, similarSlotAtom } from '../stores/questionCardAi.atoms';

/**
 * 빌드 화면을 벗어날 때 두 슬롯을 비운다. 슬롯 atom 은 앱 전역 저장소에 있어, 실패 슬롯이
 * 남은 채 같은 퀴즈(같은 문항 id)를 다시 열면 새 편집 세션에 지난 실패 UI 가 나타난다.
 */
export const useResetQuestionCardAiSlots = () => {
  const store = useStore();
  useEffect(
    () => () => {
      store.set(similarSlotAtom, {});
      store.set(fillSlotAtom, {});
    },
    [store],
  );
};
